import React from 'react';
import "./prop.css";
import like from "../../assets/like.svg"
import Offer from '../offer/offer';

const Prop = (props) => {
    return (  
        <>
            <div className="prop">
                <div className="propimg">
                    <img className='image' src={props.img} alt="" />
                    <img className='like' src={like} alt="" />
                </div>
                <div className="proptxt">
                    <h3>{props.propname}</h3>
                    <p>{props.desc}</p>
                </div>
                <div className="offers">
                    <Offer icon={props.offer1} num={props.offer1num} ofstyle={props.ofstyle} />
                    <Offer icon={props.offer2} num={props.offer2num} ofstyle={props.ofstyle}/>
                    <Offer icon={props.offer3} num={props.offer3num} ofstyle={props.ofstyle}/>
                </div>
            </div>
        
        </>
    );
}
 
export default Prop;